import api from '@/api'

// State（状態）
// https://next.vuex.vuejs.org/ja/guide/state.html
// 状態を監視するデータ
const state = () => ({
  data: {},
  detail: {},
})

// Getters（算出プロパティ）
// https://next.vuex.vuejs.org/ja/guide/getters.html
// コンポーネントから状態を取得するプロパティまたは関数
const getters = {
  results: (state) => state.data.results,
  prev: (state) => state.data.previous,
  next: (state) => state.data.next,
  detail: (state) => state.detail,
}

// Mutations（状態変更）
// https://next.vuex.vuejs.org/ja/guide/mutations.html
// 状態を変更するメソッド
const mutations = {
  setData: (state, data) => (state.data = data),
  clearData: (state) => (state.data = []),
  setDetail: (state, detail) => (state.detail = detail),
  clearDetail: (state) => (state.detail = {}),
}

// Actions（処理）
// https://next.vuex.vuejs.org/ja/guide/actions.html
// コンポーネントからミューテーションを実行する関数
const actions = {
  clearAll({ commit }) {
    return new Promise((resolve) => {
      commit('clearData')
      commit('clearDetail')
      resolve()
    })
  },
  async fetchAll({ commit }, queryParams) {
    const response = await api.get('operate/orders/', {
      params: queryParams,
    })
    commit('setData', response.data)
  },
  async fetchData({ state, commit }, id) {
    if (Object.keys(state.detail).length > 0 && state.detail.id == id) {
      return
    }

    const response = await api.get('operate/orders/' + id + '/')
    commit('setDetail', response.data)
  },
  /**
   * データを追加する
   *
   * @param {object}
   * @return {object}
   */
  async postData({ state }, formData) {
    try {
      const response = await api.post('operate/orders/', formData)
      state.data.results.push(response.data)
    } catch (error) {
      throw error
    }
  },
  /**
   * データを更新する
   *
   * @param {object}
   * @return {object}
   */
  async patchData({ state, commit }, formData) {
    try {
      const response = await api.patch(
        'operate/orders/' + formData.id + '/',
        formData
      )
      commit('setDetail', Object.assign(state.detail, response.data))
    } catch (error) {
      throw error
    }
  },
  /**
   * データを作成または更新する
   *
   * @param {object}
   * @return {object}
   */
  async postOrPatch({ dispatch }, formData) {
    if ('client' in formData && formData['client']) {
      formData['client_id'] = formData['client']['id']
    }
    // 必要なデータのみにする
    const requiredKeys = [
      'id',
      'client_id',
      'number',
      'ordered_at',
      'memo',
      'order_items',
    ]
    const submitData = Object.fromEntries(
      Object.entries(formData).filter(([key, value]) =>
        requiredKeys.includes(key)
      )
    )
    if (submitData['order_items']) {
      submitData['order_items'] = submitData['order_items'].map((item) => {
        return {
          item_id: item.item.id,
          quantity: item.quantity,
          unit_price_at_order: item.unit_price_at_order,
          subtotal: item.subtotal,
          memo: item.memo,
        }
      })
    }

    try {
      if ('id' in submitData && submitData['id']) {
        await dispatch('patchData', submitData)
      } else {
        await dispatch('postData', submitData)
      }
    } catch (error) {
      throw error
    }
  },
  /**
   * データを削除する
   *
   * @param {number}
   * @return {void}
   */
  async deleteData({ state }, id) {
    try {
      await api.delete('operate/orders/' + id + '/')
      const index = state.data.results.findIndex((result) => result.id === id)
      state.data.results.splice(index, 1)
    } catch (error) {
      throw error
    }
  },
  /**
   * 状態を更新する
   *
   * @param {object} formData
   * @return {object}
   */
  async statusUpdate({ state, commit }, formData) {
    const requiredKeys = ['status']
    const submitData = Object.fromEntries(
      Object.entries(formData).filter(([key, value]) =>
        requiredKeys.includes(key)
      )
    )

    try {
      const response = await api.patch(
        'operate/orders/' + formData.id + '/',
        submitData
      )
      commit('setDetail', Object.assign(state.detail, response.data))
    } catch (error) {
      throw error
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
